// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 237 ? "pages" : chunkId) + "." + {"223":"794e123d","237":"69d96afe","409":"10a870cd","453":"d536a134","667":"826fab12"}[chunkId] + ".chunk.js";
};